@for (filter of filters; track trackByFn(i, filter); let i = $index) {
<app-background-effect
  tabindex="0"
  role="button"
  [effect]="filter"
  [active]="isActive(filter)"
  [activeEffect]="activeFilter"
  (error)="effectError($event)"
  [attr.data-index]="i"
  #effectRef
  data-tid="background-effects/select-effect"
></app-background-effect>
} @if (filters.length === 0) {
<av-spinner size="md"></av-spinner>
}
